import React, { useRef, useState } from 'react';
import { Box, Button, Typography } from '@material-ui/core';

const isValidResume = (payment, resume) =>
  resume &&
  resume.paymentDraftId === payment.id &&
  Boolean(resume.paymentIntentId) &&
  Boolean(resume.clientSecret) &&
  resume.amount === payment.pricing.totalAmount &&
  resume.currency === payment.pricing.currency &&
  resume.paymentStatus === 'awaiting_payment';

const PrintPaymentResumeList = ({ payments, onResumeStart, onResumeReady }) => {
  const requestInFlight = useRef(false);
  const [loadingId, setLoadingId] = useState(null);
  const [error, setError] = useState(null);

  const resumePayment = async (payment) => {
    if (requestInFlight.current) return;
    requestInFlight.current = true;
    setLoadingId(payment.id);
    setError(null);
    onResumeStart();

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/payments/${payment.id}/resume-intent`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      const resume = await response.json();
      if (!response.ok || !isValidResume(payment, resume)) {
        throw new Error(resume?.message || resume?.error?.message || 'Zahlung konnte nicht fortgesetzt werden.');
      }
      onResumeReady(payment, resume);
    } catch (resumeError) {
      setError(resumeError.message || 'Zahlung konnte nicht fortgesetzt werden.');
    } finally {
      requestInFlight.current = false;
      setLoadingId(null);
    }
  };

  return (
    <>
      {payments.map((payment) => (
        <Box key={payment.id} mb={1}>
          <Button variant="outlined" disabled={Boolean(loadingId)} onClick={() => resumePayment(payment)}>
            Unvollständige Zahlung fortsetzen – Bestellung {payment.orderId} –{' '}
            {new Intl.NumberFormat('de-DE', { style: 'currency', currency: payment.pricing.currency }).format(
              payment.pricing.totalAmount / 100
            )}{' '}
            – {new Date(payment.createdAt).toLocaleDateString('de-DE')}
          </Button>
        </Box>
      ))}
      {error && <Typography color="error">{error}</Typography>}
    </>
  );
};

export { isValidResume };
export default PrintPaymentResumeList;
